module.exports = __webpack_public_path__ + "assets/img/Logo5.88069775.png";